<div class="modal-delete-users">
  <div class="modal-delete-users__header">
    <div class="modal-delete-users__header__title">
      {{ dataTranslateUserGroups?.title }}
    </div>
    <mat-icon class="modal-delete-users__header__close" (click)="close(false)"
      >close</mat-icon
    >
  </div>
  <div class="modal-delete-users__content">
    <span> {{ dataTranslateUserGroups?.content }}</span>
  </div>
  <div class="modal-delete-users__footer">
    <button class="modal-delete-users__footer__close" (click)="close(false)">
      {{ dataTranslateUserGroups?.buttonCancel }}
    </button>
    <button class="modal-delete-users__footer__save" (click)="close(true)">
      {{ dataTranslateUserGroups?.buttonSave }}
    </button>
  </div>
</div>
